import _ from "lodash";
import React, { useState, useRef, useEffect } from "react";
import Select from "react-select";
import { injectIntlTranslation } from "@carrier-ecat/workflowui-globalfunctions";
import { injectIntl } from "react-intl";
import { Tooltip } from "@material-ui/core";

// Sample data object
const dataTemp = {
  ddId: "29238c05-0b44-449c-aa1d-8fd1fa7ae35e",
  ddName: "demo",
  description: "asd",
  configGroup: {
    id: "ca446d96-df78-425f-a1be-b0bb7690ae9e",
    name: "errr",
    modelId: "f833085d-41ad-47e3-ab71-366293cf8e6e",
    sort: null,
    model: null,
    ddNamesForUi: [],
  },
  columnType: "DISCRETE",
  sort: 1,
  ddValues: [
    {
      id: "b7694497-ecd7-47b0-b359-41c39482fa94",
      ddNameId: "29238c05-0b44-449c-aa1d-8fd1fa7ae35e",
      value: "demo1",
      description: "",
      isActive: true,
      sort: 1,
      ddName: null,
    },
    {
      id: "820ad45e-03c7-40a7-8e11-7f2d6116734a",
      ddNameId: "29238c05-0b44-449c-aa1d-8fd1fa7ae35e",
      value: "demo3",
      description: "",
      isActive: true,
      sort: 1,
      ddName: null,
    },
    {
      id: "764cbb82-bb5d-4789-8dc4-8e64c512364f",
      ddNameId: "29238c05-0b44-449c-aa1d-8fd1fa7ae35e",
      value: "demo2",
      description: "",
      isActive: true,
      sort: 1,
      ddName: null,
    },
  ],
};

const customStyles = {
  control: (provided) => ({
    ...provided,
    minHeight: "25px", // Set the minimum height to 25px
    height: "25px", // Set the height to 25px
    borderColor: "#ccc",
    color: "#0000ff",
    fontSize: "12px", // Adjust the font size if needed to fit in the 25px height
    border: "none",
    background: "#e7f1fe",
    outline: "none",
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: "25px", // Ensure the value container has the same height
    padding: "0 6px", // Adjust padding to align text correctly
  }),
  input: (provided) => ({
    ...provided,
    margin: "0", // Remove margin to fit within the 25px height
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: "25px", // Ensure the indicators container has the same height
    display: "none",
  }),
  option: (provided) => ({
    ...provided,
    minheight: "25px", // Set the height of each option to 25px
    maxHeight: "fit-content",
    display: "flex",
    alignItems: "center",
    color: "black",
    fontSize: "12px", // Adjust the font size for the dropdown options
  }),
};

const AutocompleteSelect = ({
  data = dataTemp,
  ddName,
  value,
  onChange,
  setIsUnsaveChanges,
  intl = null,
}) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const previousInputValueRef = useRef("");
  const [options, setoptions] = useState([]);

  const dynamicSort = (arr, key) => {
    return _.sortBy(arr, (item) => {
      const value = item[key];

      const numericValue = parseFloat(value);

      if (!isNaN(numericValue) && isFinite(numericValue)) {
        return numericValue;
      } else {
        return value.toString();
      }
    });
  };

  useEffect(() => {
    let tempOption = data.filter((ele) => ele.label === ddName);
    const [filterTemp = {}] = tempOption;
    const { ddValues = [] } = filterTemp;

    const optionsTemp = ddValues.map((valuet) => ({
      value: valuet?.value.trim(),
      label: injectIntlTranslation(
        intl,
        valuet?.value.trim(),
        valuet?.value.trim()
      ),
    }));

    // const t = _.sortBy(optionsTemp, "label");
    const t = dynamicSort(optionsTemp, "label");

    setSelectedOption({
      value: value.trim(),
      label: injectIntlTranslation(intl, value.trim(), value.trim()),
    });
    setoptions(t);
  }, [data, ddName]);

  const handleChange = (option) => {
    setSelectedOption(option);
    previousInputValueRef.current = option;
    if (option) onChange(option?.value);
    setIsUnsaveChanges(true);
  };

  const handleBlur = () => {
    if (!selectedOption) {
      setSelectedOption(previousInputValueRef.current);
    }
  };

  return (
    <Tooltip title={selectedOption?.value || ""}>
      <div style={{ width: "100px" }}>
        <Select
          value={selectedOption}
          onChange={handleChange}
          options={options}
          onBlur={handleBlur}
          styles={customStyles}
          isClearable
          placeholder="Search"
          noOptionsMessage={() => "No options found"}
          menuPosition="fixed"
          menuPlacement="auto"
        />
      </div>
    </Tooltip>
  );
};

export default injectIntl(AutocompleteSelect);
